import { NewsPostType, PostType } from 'src/hook/usePosts'
import { PostImage } from '../postImage'
import { PostVideo } from '../postVideo'
import { PostLive } from '../postLive'
import { PostUrl } from '../postUrl'
import { PostMediaContainerProps } from './postMediaContainer.types'

const PostMediaContainer = ({ post, isEdit = false }: PostMediaContainerProps) => {
  switch (post?.postType) {
    case PostType.IMAGE:
      return <PostImage post={post} isEdit={isEdit} />

    case PostType.URL:
      return <PostUrl post={post} isEdit={isEdit} />

    case PostType.VIDEO:
      return <PostVideo post={post} isEdit={isEdit} />

    case NewsPostType.LIVE:
      return <PostLive post={post} />

    default:
      return null
  }
}

export default PostMediaContainer
